import moment from 'moment';
import { http } from 'vue';
import { API_BASE_PATH } from '../../consts';
export default {
  load({ commit }) {
    return http.post(API_BASE_PATH + '/api/get-main-data').then(res => {
      if (res.data) {
        const { AuditoriumInfo, Tickets, Films } = res.data.Response.ShowSchedule;
        const movieList = Films.Film;
        movieList.forEach(movie => {
          movie.Slug = movie.Title.replace(/ /g, '-').toLowerCase();
        });
        commit('movieList', { movieList });
      } else {
        throw 'data is empty, please try again';
      }
    });
  },

  loadMovie({ commit, getters, dispatch }, { title }) {
    return http
      .post(API_BASE_PATH + '/api/get-film-by-name', { params: { filmname: title } })
      .then(res => {
        if (res && res.body) {
          const movie = res.body.Film;
          movie.Slug = movie.Title.replace(/ /g, '-').toLowerCase();
          if (!getters.selectedMovie || movie.FilmCode !== getters.selectedMovie.FilmCode) {
            dispatch('clearLocalStorage', null, { root: true });
          }
          commit('selectedMovie', { movie });
          const { Show } = movie.Shows;
          const availableDateTimes = Show ? (Show.length ? Show : [Show]) : [];

          const availableTimes = [];
          const availableDays = [];
          const keys = {};
          const range = [0, 0];

          if (availableDateTimes.length > 0) {
            availableDateTimes.forEach(show => {
              const momentTime = moment(show.DT, 'YYYYMMDDHHmm');
              if (!range[0] || momentTime.isBefore(range[0])) {
                range[0] = momentTime;
              }
              if (!range[1] || momentTime.isAfter(range[1])) {
                range[1] = momentTime;
              }
              // const momentTime = moment(date);
              const key = momentTime.format('YYYY-MM-DD');

              if (!keys[key]) {
                if (availableDays.length < 7) {
                  availableDays.push({
                    key,
                    val: key,
                    day: momentTime.format('DD'),
                    dayName: momentTime.format('ddd'),
                    number: show.ID
                  });
                }
                keys[key] = key;
              }

              availableTimes.push({
                key,
                time: momentTime.format('hh:mm'),
                meridiem: momentTime.format('A'),
                value: show,
                number: show.ID
              });
            });
            commit('availableTimes', { availableTimes });
            commit('availableDays', { availableDays });
            const availableRange = {
              minDate: range[0].toISOString(),
              maxDate: range[1].toISOString()
            };
            commit('availableRange', { availableRange });
          } else {
            throw 'There is no available show time for this movie';
          }
        } else {
          commit('selectedMovie', { movie: {} });
        }
      });
  }
};
